<template>
  <div class="css-script-ads"></div>
</template>

<script setup>
import { onMounted, onUnmounted } from "vue";
import { detectDeviceType } from "~/helpers/device.js";

onMounted(() => {
  if (detectDeviceType() === 'desktop') return;

  if (typeof requestIdleCallback !== 'undefined') {
    requestIdleCallback(() => initBanner());
  } else {
    setTimeout(() => initBanner(), 100);
  }
});

// The smart-app-banner library appends its element straight to
// document.body (outside Vue's tree), so leaving the homepage via SPA
// navigation would otherwise leave it behind on every other page — this
// component is now only rendered on the homepage (app.vue), but Vue's
// unmount alone wouldn't remove that node.
onUnmounted(() => {
  document.querySelector(".smartbanner")?.remove();
});

function initBanner() {
  const deviceType = detectDeviceType();
  runSmartBanner(deviceType);

  nextTick(() => {
    const banner = document.querySelector('.smartbanner');
    if (banner) {
      banner.classList.add('smartbanner-animate');
    }
  });
}

function runSmartBanner(deviceType) {
  const userLang = (navigator.language || navigator.userLanguage).split("-")[0];
  const bannerElement = document.querySelector(".smartbanner");
  if (bannerElement) {
    bannerElement.parentNode.removeChild(bannerElement);
  }

  const init = () => new window.SmartBanner({
    daysHidden: 0,
    daysReminder: 90,
    appStoreLanguage: userLang,
    title: "Salamis Bay Conti Resort & Spa",
    author: "Salamis Bay Conti Resort & Spa",
    button: "OPEN",
    force: deviceType,
  });

  if (typeof window.SmartBanner !== 'undefined') {
    init();
  } else {
    window.addEventListener('smartbanner:ready', init, { once: true });
  }
}
</script>

<style lang="scss">
.main-body {
  overflow: hidden;
}

:global(.smartbanner) {
  opacity: 0;
  transform: translateY(-100%);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

:global(.smartbanner.smartbanner-animate) {
  opacity: 1;
  transform: translateY(0);
}
</style>